<template>
  <v-card flat style="width: 620px">
    <v-row flat>
      <h1 class="heading-1">Settings</h1>
    </v-row>
    <div class="mt-6">
      <template>
        <v-tabs flat v-model="tabs" class="tabs_slider">
          <v-tab style="text-transform: none !important"> Currencies </v-tab>
          <v-tab style="text-transform: none !important"> Languages </v-tab>
        </v-tabs>
      </template>
    </div>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-card flat style="width: 650px; height: 600px" class="mt-4">
          <div>
            <v-row class="d-flex justify-space-between" flat>
              <v-col cols="12" md="8" flat style="color: #f2f3f9">
                <v-text-field
                  flat
                  background-color="#F6F8FC"
                  solo
                  class="feild"
                  prepend-inner-icon="mdi-magnify"
                  label="Search.."
                  v-model="search"
                  @input="filter"
                  single-line
                >
                </v-text-field>
              </v-col>

              <v-col class="d-flex justify-end" cols="12" md="4">
                <v-card flat class="d-flex align-center">
                  <!-- <v-btn color="primary">Add new</v-btn> -->
                  <v-dialog
                    v-model="add_dialog"
                    persistent
                    max-width="600"
                    style="overflow-y: hidden"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="text_style px-8 py-6"
                        depressed
                      >
                        Add New
                      </v-btn>
                    </template>
                    <v-card>
                      <div class="px-5 py-4 d-flex justify-space-between">
                        <span
                          class="pl-0"
                          style="
                            color: #222222;
                            text-transform: none !important;
                          "
                        >
                          Currency
                        </span>
                        <v-icon @click="add_dialog = false">mdi-close</v-icon>
                      </div>
                      <v-divider class="mt-0 mb-0 mx-4 test"></v-divider>
                      <v-divider class="mt-0 mb-0 mx-4"></v-divider>

                      <v-card flat style="width: 600px" class="mt-6">
                        <div>
                          <currency-component />
                        </div>
                      </v-card>
                    </v-card>
                  </v-dialog>
                </v-card>
              </v-col>
            </v-row>
            <v-card class="mt-8 mb-14" flat>
              <v-data-table
                :headers="headers"
                :search="search"
                :items="DataTableOne"
                :hide-default-header="true"
                :hide-default-footer="true"
                style="background: #f6f8fc"
                background="#F6F8FC;"
              >
                <template v-slot:[`item.currency`]="{ item }" class="pa-8">
                  <span class="text_heading_TB"> {{ item.currency }} </span>
                </template>
                <template v-slot:[`item.index`]="{ item }" class="pa-8">
                  <span class="text_heading_tbt"> {{ item.index }} </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }" class="pa-8">
                  <div class="d-flex justify-end mt-3 mb-3 ma-2">
                    <v-icon color="#EAA413" v-if="item.isHidden"
                      >mdi-pin-outline</v-icon
                    >
                    <v-icon color="transparent" v-else>mdi-pin-outline</v-icon>
                    <v-btn icon @click="toggleIsPlaying(item.index)">
                      <v-icon v-if="item.isPlaying" color="primary"
                        >mdi-eye</v-icon
                      >
                      <v-icon v-else>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn depressed icon>
                      <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                    <!-- <v-dialog v-model="dialog" persistent max-width="290">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ml-3"
                          color="#A1A1A6"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-delete-outline
                        </v-icon>
                      </template>
                      <v-card>
                        <v-card-title class="text-h5"> Warning </v-card-title>
                        <v-card-text class="index_span_2_style"
                          >Are you sure you want to delete?</v-card-text
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="red darken-1"
                            text
                            @click="dialog = false"
                          >
                            Confirm
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog> -->
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat style="width: 650px; height: 600px" class="mt-4">
          <div>
            <v-row>
              <v-col cols="8" md="8">
                <v-card flat style="color: #f2f3f9">
                  <v-text-field
                    flat
                    background-color="#F6F8FC"
                    solo
                    class="feild"
                    prepend-inner-icon="mdi-magnify"
                    label="Search.."
                    v-model="search"
                    @input="filter"
                    single-line
                  >
                  </v-text-field>
                </v-card>
              </v-col>

              <v-col class="d-flex justify-end" cols="6" md="4">
                <v-card flat class="d-flex align-center">
                  <v-dialog
                    v-model="language_dialog"
                    persistent
                    max-width="600"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="text_style px-8 py-6"
                        depressed
                      >
                        Add New
                      </v-btn>
                    </template>
                    <v-card>
                      <div class="px-5 py-4 d-flex justify-space-between">
                        <span
                          class="pl-0"
                          style="
                            color: #222222;
                            text-transform: none !important;
                          "
                        >
                          Currency
                        </span>
                        <v-icon @click="language_dialog = false"
                          >mdi-close</v-icon
                        >
                      </div>
                      <v-divider class="mt-0 mb-0 mx-4 test"></v-divider>
                      <v-divider class="mt-0 mb-0 mx-4"></v-divider>

                      <v-card flat style="width: 600px" class="mt-6">
                        <div>
                          <langaage-component />
                        </div>
                      </v-card>
                    </v-card>
                  </v-dialog>
                </v-card>
              </v-col>
            </v-row>
            <v-card class="mt-8 mb-14" outlined flat>
              <v-data-table
                :headers="headerss"
                :search="search"
                :items="DataTabletwo"
                :hide-default-header="true"
                :hide-default-footer="true"
                style="background: #f6f8fc"
                background="#F6F8FC;"
              >
                <template v-slot:[`item.language`]="{ item }" class="pa-8">
                  <span class="text_heading_TB">
                    {{ item.language }}
                    <span class="text_heading_tbt"> {{ item.language0 }} </span>
                  </span>
                </template>

                <template v-slot:[`item.actions`]="{ item }" class="pa-8">
                  <div class="d-flex justify-end mt-3 mb-3 ma-2">
                    <v-icon color="#EAA413" v-if="item.isHidden"
                      >mdi-pin-outline</v-icon
                    >
                    <v-icon color="transparent" v-else>mdi-pin-outline</v-icon>
                    <v-btn icon @click="toggleisShow(item.language)">
                      <v-icon v-if="item.isShow" color="primary"
                        >mdi-eye</v-icon
                      >
                      <v-icon v-else>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn depressed icon>
                      <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                    <!-- <v-dialog v-model="dialog1" persistent max-width="290">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ml-3"
                          color="#A1A1A6"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-delete-outline
                        </v-icon>
                      </template>
                      <v-card>
                        <v-card-title class="text-h5"> Warning </v-card-title>
                        <v-card-text class="index_span_2_style"
                          >Are you sure you want to delete?</v-card-text
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green darken-1"
                            text
                            @click="dialog1 = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="red darken-1"
                            text
                            @click="dialog1 = false"
                          >
                            Confirm
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog> -->
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import CurrencyComponent from "../../components/Setting/CurrencyComponent.vue";
import LangaageComponent from "../../components/Setting/langaageComponent.vue";
export default {
  data() {
    return {
      search:"",
      add_dialog: false,
      language_dialog: false,
      isPlaying: false,
      isShow: false,
      dialog: false,
      dialog1: false,
      tabs: null,

      headers: [
        { text: "", value: "currency" },
        { text: "", value: "index" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [
        {
          currency: "USD - $",
          index: "Dolar estadounidense",
          isPlaying: false,
        },
        {
          currency: "AUS - AU$",
          index: "Dolar australiano",
          isPlaying: false,
        },
        {
          currency: "ARS - ARS$",
          index: "Peso argentino",
          isPlaying: false,
        },

        {
          currency: "BRL - R$",
          index: "Reales",
          isPlaying: false,
        },
      ],
      headerss: [
        { text: "", value: "language" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTabletwo: [
        {
          language: "Spanish ",
          language0: "(Latinoamérica)",
          isShow: false,
        },
        {
          language: "English ",
          isShow: false,
        },
        {
          language: "Portuguese ",
          isShow: false,
        },

        {
          language: "Deutsch",
          isShow: false,
        },
      ],
    };
  },
  methods: {
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;

          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
      
    },

    toggleIsshow(objj) {
      this.DataTabletwo = this.DataTabletwo.map((e) => {
        if (e.language === objj) {
          e.isShow = !e.isShow;

          return e;
        }
        return e;
      });
      this.isShow = !this.isShow;
    },
  },
  components: { CurrencyComponent, LangaageComponent },
};
</script>
<style scoped>
.tabs_slider {
  color: #eaa413;

  font-weight: 800;
  font-size: 16px;
  line-height: 21px;
  border-bottom: 2px solid #e1e4e7;
}

.feild {
  background-color: #f6f8fc;
  border: 1px solid #f2f3f9;

  border-radius: 6px;
  height: 50px;
}
.text_heading_TB {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;

  color: #222222;
}
.text_heading_tbt {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(8, 8, 22, 0.38);
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.test {
  border-width: 1px !important;
  border-color: #f6a70a !important;

  width: 75px;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>